import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/index.css';

import React from 'react';

import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    RouterProvider,
} from 'react-router-dom';

import { PayPalScriptProvider } from '@paypal/react-paypal-js';

import App from './App';
import AdminRoute from './components/route/AdminRoute';
import PrivateRoute from './components/route/PrivateRoute';
import reportWebVitals from './reportWebVitals';
import CartScreen from './screens/checkout/CartScreen';
import SharedCartScreen from './screens/checkout/SharedCartScreen';
import HomeScreen from './screens/home/HomeScreen';
import LoginScreen from './screens/user/LoginScreen';
import OrderListScreen from './screens/admin/OrderListScreen';
import SalesReportScreen from './screens/admin/SalesReportScreen';
import OrderScreen from './screens/checkout/OrderScreen';
import PaymentScreen from './screens/checkout/PaymentScreen';
import PlaceOrderScreen from './screens/checkout/PlaceOrderScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import OutOfStockProductsScreen from './screens/admin/OutOfStockProductsScreen';
import ProductScreen from './screens/product/ProductScreen';
import ProfileScreen from './screens/user/ProfileScreen';
import OrdersScreen from './screens/user/OrdersScreen';
import RegisterScreen from './screens/user/RegisterScreen';
import ShippingScreen from './screens/checkout/ShippingScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import CompanySelectScreen from './screens/admin/CompanySelectScreen';
import store from './store';
import CategoryListScreen from './screens/product/CategoryListScreen';
import CategoryProductsScreen from './screens/product/CategoryProductsScreen';
import BrandProductsScreen from './screens/product/BrandProductsScreen';
import DiscountProductsScreen from './screens/product/DiscountProductsScreen';
import CompanyScreen from './screens/product/CompanyScreen';
import PayPhoneOrder from './components/checkout/PayPhoneOrder';
import CompanyListScreen from './screens/admin/CompanyListScreen';
import ForgotPasswordScreen from './screens/user/ForgotPasswordScreen';
import ContactScreen from './screens/home/ContactScreen';
import CareersScreen from './screens/home/CareersScreen';
import PartnersScreen from './screens/home/PartnersScreen';
import AboutUsScreen from './screens/home/AboutUsScreen';
import PartnerListScreen from './screens/admin/PartnerListScreen';
import PromotionScreen from './screens/home/PromotionScreen';
import PromotionListScreen from './screens/admin/PromotionListScreen';
import PromotionEditScreen from './screens/admin/PromotionEditScreen';
import DiscountListScreen from './screens/admin/DiscountListScreen';
import BrandListScreen from './screens/admin/BrandListScreen';
import InStorePriceCheckerScreen from './screens/user/InStorePriceCheckerScreen';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<App />}>
            <Route index={true} path="/" element={<HomeScreen />} />
            <Route path="/search" element={<HomeScreen />} />
            <Route path="/search/:keyword" element={<HomeScreen />} />
            <Route path="/page/:pageNumber" element={<HomeScreen />} />
            <Route path="/search/page/:pageNumber" element={<HomeScreen />} />
            <Route path="/search/:keyword/page/:pageNumber" element={<HomeScreen />} />
            <Route path="/category/:categoryId" element={<CategoryProductsScreen />} />
            <Route
                path="/category/:categoryId/page/:pageNumber"
                element={<CategoryProductsScreen />}
            />
            <Route path="/brand/:brandId" element={<BrandProductsScreen />} />
            <Route path="/brand/:brandId/page/:pageNumber" element={<BrandProductsScreen />} />
            <Route path="/discounts" element={<DiscountProductsScreen />} />
            <Route path="/discounts/page/:pageNumber" element={<DiscountProductsScreen />} />
            <Route path="/company/:ruc" element={<CompanyScreen />} />
            <Route path="/company/:ruc/page/:pageNumber" element={<CompanyScreen />} />
            <Route path="/product/:_id" element={<ProductScreen />} />
            <Route path="/cart" element={<CartScreen />} />
            <Route path="/shared-cart/:token" element={<SharedCartScreen />} />
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/register" element={<RegisterScreen />} />
            <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
            <Route path="/contact" element={<ContactScreen />} />
            <Route path="/quienes-somos" element={<AboutUsScreen />} />
            <Route path="/careers" element={<CareersScreen />} />
            <Route path="/partners" element={<PartnersScreen />} />
            <Route path="/promotion/:promotionId" element={<PromotionScreen />} />
            <Route path="/promotion/:promotionId/page/:pageNumber" element={<PromotionScreen />} />

            <Route path="" element={<PrivateRoute />}>
                <Route path="/shipping" element={<ShippingScreen />} />
                <Route path="/payment" element={<PaymentScreen />} />
                <Route path="/placeorder" element={<PlaceOrderScreen />} />
                <Route path={'/checkout/:id'} element={<OrderScreen />} />
                <Route path={'/profile'} element={<ProfileScreen />} />
                <Route path={'/orders'} element={<OrdersScreen />} />
                <Route path={'/orders/page/:pageNumber'} element={<OrdersScreen />} />
                <Route path="/in-store-price-checker" element={<InStorePriceCheckerScreen />} />
                <Route path="/order/:id" element={<OrderScreen />} />
                <Route path="/pporder" element={<PayPhoneOrder />} />
            </Route>

            <Route path="" element={<AdminRoute />}>
                <Route path="/admin/select-company" element={<CompanySelectScreen />} />
                <Route path="/admin/orderlist" element={<OrderListScreen />} />
                <Route path="/admin/orderlist/page/:pageNumber" element={<OrderListScreen />} />
                <Route path="/admin/orderlist/search/:keyword" element={<OrderListScreen />} />
                <Route
                    path="/admin/orderlist/search/:keyword/page/:pageNumber"
                    element={<OrderListScreen />}
                />
                <Route path="/admin/sales-report" element={<SalesReportScreen />} />

                <Route path="/admin/productlist" element={<ProductListScreen />} />
                <Route path="/admin/productlist/page/:pageNumber" element={<ProductListScreen />} />
                <Route path="/admin/productlist/search/:keyword" element={<ProductListScreen />} />
                <Route
                    path="/admin/productlist/search/:keyword/page/:pageNumber"
                    element={<ProductListScreen />}
                />

                <Route path="/admin/outofstock" element={<OutOfStockProductsScreen />} />
                <Route
                    path="/admin/outofstock/page/:pageNumber"
                    element={<OutOfStockProductsScreen />}
                />
                <Route
                    path="/admin/outofstock/search/:keyword"
                    element={<OutOfStockProductsScreen />}
                />
                <Route
                    path="/admin/outofstock/search/:keyword/page/:pageNumber"
                    element={<OutOfStockProductsScreen />}
                />

                <Route path="/admin/userlist" element={<UserListScreen />} />
                <Route path="/admin/userlist/page/:pageNumber" element={<UserListScreen />} />
                <Route path="/admin/userlist/search/:keyword" element={<UserListScreen />} />
                <Route
                    path="/admin/userlist/search/:keyword/page/:pageNumber"
                    element={<UserListScreen />}
                />
                <Route path={'/admin/user/:id/edit'} element={<UserEditScreen />} />
                <Route path="/admin/categorylist" element={<CategoryListScreen />} />
                <Route path="/admin/companylist" element={<CompanyListScreen />} />
                <Route path="/admin/partnerlist" element={<PartnerListScreen />} />
                {/*Solo para development*/}
                {/*<Route path="/admin/migration" element={<AddressMigrationTool />} />*/}
                
                <Route path="/admin/eventlist" element={<PromotionListScreen />} />
                <Route path="/admin/event/:id/edit" element={<PromotionEditScreen />} />
                <Route path="/admin/discountlist" element={<DiscountListScreen />} />
                <Route path="/admin/brandlist" element={<BrandListScreen />} />
            </Route>
        </Route>
    )
);

const initialOptions = {
    clientId: 'test',
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// Suppress "ResizeObserver loop completed with undelivered notifications" error in development
// This error is benign and often caused by third-party libraries like Swiper or MUI.
// It can trigger the error overlay in CRA (Create React App) and disrupt the user experience.
if (process.env.NODE_ENV === 'development') {
    const resizeObserverErrors = [
        'ResizeObserver loop completed with undelivered notifications.',
        'ResizeObserver loop completed with undelivered notifications',
        'ResizeObserver loop limit exceeded',
    ];

    // Monkey-patch ResizeObserver to wrap callback in requestAnimationFrame
    // This prevents the "loop limit exceeded" error by deferring the callback
    if (window.ResizeObserver) {
        const OriginalResizeObserver = window.ResizeObserver;
        window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
            constructor(callback) {
                super((entries, observer) => {
                    window.requestAnimationFrame(() => {
                        callback(entries, observer);
                    });
                });
            }
        };
    }

    const originalError = window.onerror;
    window.onerror = (message, source, lineno, colno, error) => {
        const msg = message ? message.toString() : '';
        if (resizeObserverErrors.some((err) => msg.includes(err))) {
            return true;
        }
        if (originalError) {
            return originalError(message, source, lineno, colno, error);
        }
        return false;
    };

    const originalAddEventListener = window.addEventListener;
    window.addEventListener = function (type, listener, options) {
        if (type === 'error') {
            const originalListener = listener;
            listener = function (event) {
                const msg = event.message || (event.error && event.error.message) || '';
                if (resizeObserverErrors.some((err) => msg.includes(err))) {
                    event.stopImmediatePropagation();
                    return;
                }
                if (typeof originalListener === 'function') {
                    return originalListener.apply(this, arguments);
                }
            };
        }
        if (type === 'unhandledrejection') {
            const originalListener = listener;
            listener = function (event) {
                const msg = (event.reason && event.reason.message) || '';
                if (resizeObserverErrors.some((err) => msg.includes(err))) {
                    event.stopImmediatePropagation();
                    return;
                }
                if (typeof originalListener === 'function') {
                    return originalListener.apply(this, arguments);
                }
            };
        }
        return originalAddEventListener.call(window, type, listener, options);
    };
}

root.render(
    <React.StrictMode>
        <HelmetProvider>
            <Provider store={store}>
                <PayPalScriptProvider deferLoading={true} options={initialOptions}>
                    <RouterProvider router={router} />
                </PayPalScriptProvider>
            </Provider>
        </HelmetProvider>
    </React.StrictMode>
);

reportWebVitals();